export default "__VITE_ASSET__DfcgEmWY__"